import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  PRE_SALES_LISTING,
  STATUS_LIST,
  DEAL_STATUS_LIST,
  UPDATE_LEAD_STATUS,
  VIEW_DETAILS,
  VIEW_CONTRACT,
  FILTER_DROPDOWN_LIST,
  FETCH_ZONES_LIST,
} from './type';

export const getPreSaleListing = (queryObj = null, page = 1) => async (
  dispatch
) => {
  let filterQuery = '';
  if (queryObj !== null) {
    filterQuery = `?lead_id=${queryObj.leadID}&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&lead_cat=${queryObj.lead_cat}&lcfrom_date=${queryObj.lcfromDate}&lcto_date=${queryObj.lctoDate}&ncfrom_date=${queryObj.ncfromDate}&ncto_date=${queryObj.nctoDate}&page=${page}`;
  }

  const teamName = await JSON.parse(localStorage.getItem('profileDetails'))[0]
    .team_id;
  const departmentName = await JSON.parse(
    localStorage.getItem('profileDetails')
  )[0].department_id;
  let apiUrl;
  if (departmentName && departmentName === 2) {
    if (teamName && teamName === 7) {
      apiUrl = queryObj
        ? `${Config.preSalesList.type}${filterQuery}`
        : Config.preSalesList.type;
    } else if (teamName && teamName === 9) {
      apiUrl = queryObj
        ? `${Config.preSalesList.listSupply}${filterQuery}`
        : Config.preSalesList.listSupply;
    } else if (teamName && teamName === 8) {
      apiUrl = queryObj
        ? `${Config.preSalesList.listApartments}${filterQuery}`
        : Config.preSalesList.listApartments;
    } else {
      apiUrl = queryObj
        ? `${Config.preSalesList.listAlliance}${filterQuery}`
        : Config.preSalesList.listAlliance;
    }
  }
  dispatch({
    type: PRE_SALES_LISTING,
    payload: {},
  });
  const res = await callWebService(
    callTypes.get,
    '',
    `${apiUrl}${queryObj === null && `?status=1,2,3,4,9&page=${page}`}`
  );
  // console.log(res);
  if (res) {
    const { data } = res;
    dispatch({
      type: PRE_SALES_LISTING,
      payload: data.response?.data ?? data.data ?? {},
    });
    return true;
  }
};

export const getStatusList = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.preSalesList.status
  );
  if (res) {
    const { data } = res;
    dispatch({ type: STATUS_LIST, payload: data.response?.data ?? data.data });
    return true;
  }
};

export const getDealStatusList = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.preSalesList.dealStatus
  );
  if (res) {
    const { data } = res;
    dispatch({ type: DEAL_STATUS_LIST, payload: data.response?.data ?? data.data });
    return true;
  }
};


export const UpdateLeadStatus = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.put,
    data,
    `${Config.preSalesList.updateStatus}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: UPDATE_LEAD_STATUS, payload: data.response });
    return true;
  }
};

export const getListFilterData = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.listFilterData.fillterDropdown}?stage=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FILTER_DROPDOWN_LIST, payload: data.response ?? { data: data.data } });
    return true;
  }
};

export const fetchZones = (val) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.listFilterData.fetchZone}${val}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FETCH_ZONES_LIST, payload: data.response });
    return true;
  }
};

export const getDetails = (requestData) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.viewDetails.view}?lead_id=${requestData.lead_id}&site_id=${requestData.site_id}&lead_type=${requestData.lead_type}`
  );
  if (res?.data?.status_code === 403) {
    return null;
  }
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: VIEW_DETAILS, payload: data.response.data });
    return true;
  }
};

export const getContractDetails = (requestData) => async (dispatch) => {
  const params = new URLSearchParams();
  if (requestData?.lead_id != null && requestData.lead_id !== '') {
    params.set('lead_id', String(requestData.lead_id));
  }
  if (requestData?.commId != null && requestData.commId !== '') {
    params.set('comm_id', String(requestData.commId));
  }
  const leadType = requestData?.lead_type;
  if (
    leadType != null &&
    leadType !== '' &&
    String(leadType) !== 'undefined' &&
    String(leadType) !== 'null'
  ) {
    params.set('lead_type', String(leadType));
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.viewDetails.viewContract}?${params.toString()}`
  );
  if (res?.data?.status_code === 403) {
    return null;
  }
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: VIEW_CONTRACT, payload: data.response.data });
    return true;
  }
};